module.exports = __webpack_public_path__ + "static/media/city-london-mining-svgrepo-com.3308dd42.svg";